import Service from 'core/decorators/Service';
import IConfigService from 'core/service/config/IConfigService';
import ServiceRegistry from 'core/util/ServiceRegistry';
import { IMutationResult } from "../../mutation/IMutationService";
import XHRResolverService from "../../resolver/impl/XHRResolver.service";

@Service()
export default class ConfigService extends IConfigService {

	constructor() {
		super();
	}

	public getConfig(key: string = ""): Promise<object> {

		// bypass IQueryService and use the XHRResolver directly for its caching policy
		// this is generally not good practice
		const resolver = ServiceRegistry.get(XHRResolverService);

		const query = `
			query {
				config${key && '(key: "' + key + '")'}
			}
		`;

		return resolver.execute(query);
	}

	public getContextProperties(): Promise<object> {
		
		const resolver = ServiceRegistry.get(XHRResolverService);

		const query = `
			query {
				contextProperties
			}
		`;

		return resolver.execute(query);
	}

	public saveConfig(config: object, key: string = ""): Promise<IMutationResult<object>> {
		const metaTages = config["contextProperties"] && config["contextProperties"]["app.metaTages"];
		let parseMetages = false;
		let parsedMetaTages: object = {};
		if (metaTages && typeof metaTages === 'string') {
			try {
				const parsed = JSON.parse(metaTages);
				if (
					parsed &&
					typeof parsed === 'object' &&
					!Array.isArray(parsed) &&
					Object.keys(parsed).length > 0
				) {
					parseMetages = true;
					parsedMetaTages = parsed;
				}
			} catch (err) {
				console.log("Invalid metaTages JSON");
			}
		}
		const clonedConfig = {
			...config,
			contextProperties: {
				...config["contextProperties"],
				"app.metaTages": parseMetages ? parsedMetaTages : {},
			}
		};
		const finalString = JSON.stringify(clonedConfig);

		// serialize the config object
		const escaped = finalString.replace(/"/g, '\\"').replace(/\\n/g, "\\\\n");

		// bypass IQueryService and use the XHRResolver directly for its caching policy
		// this is generally not good practice
		const resolver = ServiceRegistry.get(XHRResolverService);

		const mutation = `
			mutation {
				configCreate(payload: "${escaped}"${key && ', key: "' + key + '"'}) {
					operationPerformed
				}
			}
		`;

		return resolver.execute(mutation);
	}

	public getLayout(): Promise<object> {

		// bypass IQueryService and use the XHRResolver directly for its caching policy
		// this is generally not good practice
		const resolver = ServiceRegistry.get(XHRResolverService);

		const query = `
			query {
				layout
			}
		`;

		return resolver.execute(query);
	}

	public getServiceId(): string {
		return IConfigService.DEFAULT_ID;
	}
}



// WEBPACK FOOTER //
// ./src/core/service/config/impl/Config.service.ts